import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@cotera/client/v0/components/ui/dropdown-menu';
import { FormValues } from './form-values';
import { cn } from '@cotera/client/v0/lib/utils';
import { Icon, IconName, Tooltip } from '@cotera/client/app/components';

type InputTypeConfig = {
  icon: IconName;
  label: string;
  description: string;
  tooltip: string;
};

const INPUT_TYPE_CONFIG: Record<FormValues['t'], InputTypeConfig> = {
  fieldTree: {
    icon: 'list-tree',
    label: 'Form Fields',
    description: 'Enter form fields',
    tooltip: 'Enter form fields',
  },
  eraQL: {
    icon: 'variable',
    label: 'EraQL Formula',
    description: 'Enter an EraQL formula',
    tooltip: 'Enter an EraQL formula',
  },
  colRef: {
    icon: 'hashtag',
    label: 'Column Reference',
    description: 'Reference a column from the dataset',
    tooltip: 'Reference a column',
  },
};

export const InputTypeSelector: React.FC<{
  formValuesType: FormValues['t'];
  onChange: (newType: FormValues['t']) => void;
}> = ({ formValuesType, onChange }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={cn(
            'flex items-center justify-center w-9 h-9 rounded-md border border-input bg-transparent shadow-xs transition-[color,box-shadow] cursor-pointer',
            'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] outline-none',
            'data-[state=open]:border-ring data-[state=open]:ring-ring/50 data-[state=open]:ring-[3px]',
            'hover:bg-muted/50'
          )}
          type="button"
        >
          <Tooltip
            side="top"
            tooltipContent={INPUT_TYPE_CONFIG[formValuesType].tooltip}
          >
            <Icon
              icon={INPUT_TYPE_CONFIG[formValuesType].icon}
              className="w-4 h-4 text-gray-600"
            />
          </Tooltip>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        {Object.entries(INPUT_TYPE_CONFIG).map(([inputType, config]) => (
          <DropdownMenuItem
            key={inputType}
            onClick={() => onChange(inputType as FormValues['t'])}
            className={cn(
              'flex items-start gap-3 px-3 py-2 cursor-pointer',
              formValuesType === inputType && 'bg-gray-100'
            )}
          >
            <Icon icon={config.icon} className="w-4 h-4 mt-0.5 text-gray-500" />
            <div className="flex-1 min-w-0">
              <div className="font-medium text-sm text-gray-900">
                {config.label}
              </div>
              <div className="text-xs text-gray-500 mt-0.5">
                {config.description}
              </div>
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
